import { StylesConfig, GroupBase } from "react-select";

interface CustomOption {
  label: string;
  value: string;
}

const selectStyle: StylesConfig<
  CustomOption,
  false,
  GroupBase<CustomOption>
> = {
  control: (provided) => ({
    ...provided,
    backgroundColor: "var(--color-background)",
    border: "1px solid var(--color-border)",
    borderRadius: "5px",
    minHeight: "44px",
    cursor: "pointer",
    color: "var(--color-light)",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "var(--color-primary)"
      : state.isFocused
      ? "var(--color-muted)"
      : "transparent",
    color:
      state.isSelected || state.isDisabled
        ? "var(--color-primary-foreground)"
        : "var(--color-foreground)",
    cursor: state.isDisabled ? "not-allowed" : "pointer",
    fontWeight: state.isSelected ? "600" : "400",
    opacity: state.isDisabled ? 0.5 : 1,
    borderRadius: "5px",
    padding: "10px 12px",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "var(--color-muted-foreground)",
    fontWeight: "500",
  }),
  valueContainer: (provided) => ({
    ...provided,
    whiteSpace: "nowrap",
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "5px",
    boxShadow: "1px 1px 10px 0px #5b5b5b26",
    backgroundColor: "var(--color-background)",
    color: "var(--color-foreground)",
  }),
  loadingIndicator: (provided) => ({
    ...provided,
    color: "transparent",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    backgroundColor: "transparent",
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    backgroundColor: "transparent",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "var(--color-primary-foreground)",
  }),
  clearIndicator: (provided) => ({
    ...provided,
    color: "var(--color-primary-foreground)",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "var(--color-muted-foreground)",
    opacity: "0.9",
  }),
  input: (provided) => ({
    ...provided,
    color: "var(--color-primary-foreground)",
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "var(--color-primary)",
    borderRadius: "5px",
    color: "var(--color-primary-foreground)",
    border: "1px solid var(--color-primary-foreground) ",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "var(--color-primary-foreground)",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "var(--color-primary-foreground)",
  }),
};

export default selectStyle;
